import React from 'react';
import s from './ThankYouPageApp.scss';
import {useControllerProps} from '../ControllerContext';
import {PageContent} from './PageContent';
import classNames from 'classnames';
import {useEnvironment} from '@wix/yoshi-flow-editor';

export enum ThankYouPageAppDataHook {
  root = 'ThankYouPageAppDataHook.root',
  rootContent = 'ThankYouPageAppDataHook.rootContent',
  blank = 'ThankYouPageAppDataHook.blank',
}

function ThankYouPageApp() {
  const {ssrError, skipRender, thankYouPageStore} = useControllerProps();
  const {isMobile} = useEnvironment();

  /* istanbul ignore if */
  if (ssrError || skipRender) {
    return <div data-hook={ThankYouPageAppDataHook.blank} />;
  }

  const className = classNames(
    s.root,
    thankYouPageStore.responsiveTYPCss ? 'responsive-typ' : 'non-responsive-typ',
    isMobile ? 'mobile-mode' : undefined
  );

  const MainContent = () => {
    return (
      <div data-hook={ThankYouPageAppDataHook.rootContent} className={s.limitContent}>
        <PageContent />
      </div>
    );
  };

  return (
    <main data-hook={ThankYouPageAppDataHook.root} className={className}>
      <MainContent />
    </main>
  );
}

// eslint-disable-next-line import/no-default-export
export default ThankYouPageApp;
